import {
  Button,
  ButtonGroup,
  type ButtonGroupProps,
  IconButton,
  type IconButtonProps,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  type MenuProps,
} from '@chakra-ui/react';
import { IconDotGrid1x3Vertical } from 'central-icons/IconDotGrid1x3Vertical';
import { useState } from 'react';

export const GridActionButton = ({
  label,
  onClick,
  additionalActions = [],
  groupProps,
  menuButtonProps,
  menuPlacement = 'bottom-end',
}: {
  label: string;
  onClick?: () => void;
  additionalActions?: {
    label: string;
    onClick: () => void;
    isDisabled?: boolean;
  }[];
  groupProps?: ButtonGroupProps;
  menuButtonProps?: IconButtonProps;
  menuPlacement?: MenuProps['placement'];
}) => {
  const hasAdditional = additionalActions.length > 0;
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <ButtonGroup
      isAttached={hasAdditional}
      variant="outline"
      colorScheme="navyBlue"
      width="140px"
      height="2rem"
      borderRadius="full"
      opacity={isMenuOpen ? 1 : 0.88}
      transition="opacity 0.2s ease-in-out"
      _hover={{ opacity: 1 }}
      {...groupProps}
    >
      <Button
        onClick={onClick}
        borderLeftRadius="full"
        borderRightRadius={hasAdditional ? '0' : 'full'}
        height="2rem"
      >
        {label}
      </Button>
      {hasAdditional && (
        <Menu
          placement={menuPlacement}
          isLazy
          isOpen={isMenuOpen}
          onOpen={() => setIsMenuOpen(true)}
          onClose={() => setIsMenuOpen(false)}
        >
          <MenuButton
            as={IconButton}
            icon={<IconDotGrid1x3Vertical size={16} />}
            height="2rem"
            aria-label="More options"
            borderRightRadius="full"
            {...menuButtonProps}
          />
          <MenuList>
            {additionalActions.map((action) => (
              <MenuItem
                key={action.label}
                onClick={action.onClick}
                isDisabled={action.isDisabled}
              >
                {action.label}
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
      )}
    </ButtonGroup>
  );
};
